import { BASEURL, Request, TRequestMethod } from "./request.ts";
import { Schema, type SchemaObject } from "./validation.ts";

export interface ESRGetEnergyCostsResponse {
   "heating_systems": [
        {
            "code": string,
            "label": string,
            "state_type": string,
            "energy_costs": number
        }
    ]
  }

  const MeasureSchema : SchemaObject = {
        "code": "string",
        "label": "string",
        "state_type": "string",
        "energy_costs": "number"
  }

export const ESRGetCostsResponseSchema : SchemaObject = {
    "heating_systems": [MeasureSchema]
  }
  

export class ESRGetEnergyCosts extends Request<ESRGetEnergyCostsResponse>{
    override method : TRequestMethod = "GET";
    override responseSchema : Schema = ESRGetCostsResponseSchema;

    constructor (
        public sessionToken: string){
        super();
    }

    override route() : string{
        return `${BASEURL}/get_energy_costs?sessionToken=${this.sessionToken}`;
    }
}